if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          container: ".m-main-product--wrapper",
          slider: ".m-media-gallery__inner",
          sliderPagination: ".swiper-pagination",
          sliderPrevEl: ".swiper-button-prev",
          sliderNextEl: ".swiper-button-next",
          navSlider: ".nav-swiper-container",
          medias: [".m-product-media--item"],
          mediaWrapper: ".m-product-media--wrapper",
          mediaZoomIns: [".m-product-media__zoom-in"],
          videos: [".media-video"],
          featuredImage: ".m-product-media",
          galleryList: ".m-media-gallery__list",
          galleryInner: ".m-media-gallery__inner",
        };

        this.navSlider = false;
        this.slider = false;
      }

      get context() {
        return this.dataset.context;
      }

      get layout() {
        return this.dataset.layout;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.section = this.closest('product-info');
        this.domNodes = queryDomNodes(this.selectors, this);
        this.enableVideoAutoplay = this.dataset.enableVideoAutoplay === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.enableVariantGroupImages = this.dataset.enableVariantGroupImages === "true";
        this.onlyMedia = this.dataset.onlyMedia === "true";
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.variantPicker = this.section.querySelector("variant-picker");

        this.setSliderOptions();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        this.setupThumbnailGrid();
        mql.addEventListener('change', () => this.updateThumbnailGrid());

        if (this.enableImageZoom) {
          this.handlePhotoswipe();
        };

        this.handleAutoplayVideo();

        this.removeAttribute("data-media-loading");
        this.domNodes.galleryInner.style.opacity = 1;
      }

      updateMediaLayout() {
        if (MinimogTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      setSliderOptions() {
        const { sliderPagination, sliderNextEl: nextEl, sliderPrevEl: prevEl } = this.domNodes;

        this.sliderOptions = {
          autoHeight: true,
          navigation: { nextEl, prevEl },
          threshold: 2,
          loop: !this.enableVariantGroupImages,
          pagination: {
            el: sliderPagination,
            clickable: true,
            type: "bullets",
          },
          on: {
            init: () => {
              this.domNodes.slider.style.opacity = 1;
              this.domNodes = queryDomNodes(this.selectors, this.section);
              requestAnimationFrame(() => {
                window.dispatchEvent(new Event("resize"));
              });
            }
          }
        };

        switch (this.layout) {
          case 'layout-4':
            break;
          case 'layout-5':
            this.sliderOptions = {
              ...this.sliderOptions,
              watchSlidesProgress: true,
              watchSlidesVisibility: true,
              breakpoints: {
                768: {
                  slidesPerView: 2,
                  slidesPerGroup: 1,
                  spaceBetween: 10,
                },
              }
            }
            break;
          case 'layout-7':
            this.sliderOptions = {
              ...this.sliderOptions,
              speed: 500,
              centeredSlides: true,
              breakpoints: {
                768: {
                  slidesPerView: 3
                }
              }
            }
        }
      }

      initSlider() {
        if (typeof this.slider !== 'object') {
          const { slider, galleryList } = this.domNodes;

          slider.classList.add('swiper-container');
          galleryList.classList.remove('m:grid');
          galleryList.classList.add('swiper-wrapper');

          this.slider = new MinimogLibs.Swiper(slider, this.sliderOptions);

          if (!this.enableVariantGroupImages) this.handleSlideChange();

          this.setupMainCounter();
        }
      }

      destroySlider() {
        const { slider, galleryList } = this.domNodes;

        slider.classList.remove('swiper-container');
        galleryList.classList.add('m:grid');
        galleryList.classList.remove('swiper-wrapper');

        if (typeof this.slider === 'object') {
          this.slider.destroy();
          this.slider = false;
        }
      }

      setupThumbnailGrid() {
        const navSlider = this.querySelector(this.selectors.navSlider);
        if (!navSlider) return;

        const wrapper = navSlider.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        wrapper.classList.add('m-thumb-grid');
        this.thumbItems = Array.from(wrapper.querySelectorAll('.swiper-slide'));
        this.thumbGridExpanded = false; // FIX: stato "griglia espansa", parte sempre compatta

        this.thumbItems.forEach((item, index) => {
          item.classList.add('m-thumb-grid__item');
          item.addEventListener('click', (e) => {
            if (item.classList.contains('m-thumb-grid__item--more')) {
              // FIX: prima apriva il lightbox sulla foto in questione; ora
              // espande la griglia mostrando tutte le miniature rimanenti.
              // Il lightbox resta comunque raggiungibile normalmente
              // cliccando sulla foto grande (contiene gia' tutte le foto,
              // a prescindere da quante miniature sono visibili qui).
              e.preventDefault();
              e.stopPropagation();
              this.thumbGridExpanded = true;
              this.updateThumbnailGrid();
              return;
            }
            // ITALMINERAL: la miniatura cambia solo la foto grande del carosello;
            // il visualizzatore a schermo intero si apre cliccando la foto grande.
            if (this.slider) this.slider.slideToLoop(index);
          });
        });

        navSlider.classList.add('m-thumb-grid__container');
        navSlider.style.opacity = 1;

        // ITALMINERAL: passando da computer a telefono (o ruotando) la griglia si ricalcola
        const mq = window.matchMedia('(max-width: 767px)');
        if (mq.addEventListener) mq.addEventListener('change', () => this.updateThumbnailGrid());

        this.updateThumbnailGrid();
      }

      // ITALMINERAL: riordina le foto (strumenti UV / cartellino / mano: quelle scelte
      // vanno in testa) senza ricostruire il carosello: ogni posizione mostra la foto
      // richiesta e lo zoom a schermo intero segue lo stesso ordine.
      // order = elenco degli indici originali delle foto, nel nuovo ordine.
      applyMediaOrder(order) {
        const items = [...this.querySelectorAll('.m-product-media--item')];
        const uniq = items.filter((m) => !m.classList.contains('swiper-slide-duplicate'));
        const imgPos = uniq.filter((m) => m.dataset.mediaType === 'image').map((m) => Number(m.dataset.index));
        const KEYS = ['src', 'srcset', 'data-im-srcset', 'sizes', 'width', 'height'];
        const TKEYS = ['src', 'srcset', 'width', 'height'];
        if (!this.imOrig) {
          this.imOrig = {};
          uniq.forEach((m) => {
            const i = Number(m.dataset.index);
            const img = m.querySelector('img');
            if (!img || m.dataset.mediaType !== 'image') return;
            const pm = m.querySelector('.m-product-media');
            this.imOrig[i] = { a: KEYS.map((k) => img.getAttribute(k)), alt: img.alt, d: pm ? Object.assign({}, pm.dataset) : null, t: null };
          });
          (this.thumbItems || []).forEach((t, i) => {
            const ti = t.querySelector('img');
            if (ti && this.imOrig[i]) this.imOrig[i].t = { a: TKEYS.map((k) => ti.getAttribute(k)), alt: ti.alt };
          });
        }
        // solo le foto si spostano (eventuali video restano al loro posto)
        const want = order.filter((i) => imgPos.includes(i));
        imgPos.forEach((i) => { if (!want.includes(i)) want.push(i); });
        const map = {};
        imgPos.forEach((pos, k) => { map[pos] = want[k]; });
        this.imMediaMap = map;

        const setAttrs = (el, keys, vals) => keys.forEach((k, n) => { if (vals[n] == null) el.removeAttribute(k); else el.setAttribute(k, vals[n]); });
        items.forEach((m) => {
          const src = this.imOrig[map[Number(m.dataset.index)]];
          if (!src) return;
          const img = m.querySelector('img');
          if (img) { setAttrs(img, KEYS, src.a); img.alt = src.alt; }
          const pm = m.querySelector('.m-product-media');
          if (pm && src.d) Object.assign(pm.dataset, src.d);
        });
        (this.thumbItems || []).forEach((t, pos) => {
          const src = this.imOrig[map[pos]];
          const ti = t.querySelector('img');
          if (src && src.t && ti) { setAttrs(ti, TKEYS, src.t.a); ti.alt = src.t.alt; }
        });
        if (this.lightbox && this.imPswpData) {
          this.lightbox.options.dataSource = this.imPswpData.map((d, pos) => {
            const from = map[pos] != null ? this.imPswpData[map[pos]] : d;
            return Object.assign({}, from, { id: String(pos) });
          });
        }
        this.dispatchEvent(new CustomEvent('im:media-order', { bubbles: true, detail: { map } }));
      }

      updateThumbnailGrid() {
        if (!this.thumbItems || !this.thumbItems.length) return;

        // ITALMINERAL: una sola riga di miniature anche da computer (meno altezza,
        // foto e informazioni in un'unica schermata); l'ultima e' sfocata con "+N".
        // Da telefono la riga scorre di lato: fino a 10 miniature, "+N" sulla decima.
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const columns = 5;
        const rows = 1;
        const cap = mobile ? 10 : columns * rows;
        const total = this.thumbItems.length;
        const nav = this.querySelector(this.selectors.navSlider);
        const grid = nav && nav.querySelector('.m-thumb-grid');
        const scroll = mobile && !this.thumbGridExpanded;
        if (nav) nav.classList.toggle('m-thumb-grid--scroll', scroll);
        if (grid) {
          // (stile in linea: le classi utility del tema hanno la precedenza sul CSS normale)
          if (scroll) {
            grid.style.setProperty('flex-wrap', 'nowrap', 'important');
            grid.style.setProperty('overflow-x', 'auto', 'important');
            grid.style.setProperty('justify-content', 'flex-start', 'important');
          } else {
            grid.style.removeProperty('flex-wrap');
            grid.style.removeProperty('overflow-x');
            grid.style.removeProperty('justify-content');
          }
        }

        // FIX: se la griglia e' stata espansa (click su "More"), mostriamo
        // sempre tutte le miniature, ignorando il cap.
        const effectiveCap = this.thumbGridExpanded ? total : cap;

        this.thumbItems.forEach((item, index) => {
          item.classList.remove('m-thumb-grid__item--more');
          const overlay = item.querySelector('.m-thumb-grid__more-overlay');
          if (overlay) overlay.remove();

          if (total <= effectiveCap || index < effectiveCap - 1) {
            item.classList.remove('m:hidden-thumb');
          } else if (index === effectiveCap - 1) {
            item.classList.remove('m:hidden-thumb');
            item.classList.add('m-thumb-grid__item--more');
            const moreOverlay = document.createElement('div');
            moreOverlay.className = 'm-thumb-grid__more-overlay';
            moreOverlay.textContent = '+' + (total - effectiveCap + 1);
            item.appendChild(moreOverlay);
          } else {
            item.classList.add('m:hidden-thumb');
          }
        });
      }

      setActiveThumbnail(index) {
        if (!this.thumbItems) return;
        this.thumbItems.forEach((item, i) => {
          item.classList.toggle('m-thumb-grid__item--active', i === index);
        });
      }

      setupMainCounter() {
        const nav = this.querySelector('.m-product-media--slider__navigation');
        if (!nav || nav.querySelector('.m-main-counter')) return;

        this.mainCounterTotal = this.querySelectorAll('.m-product-media--item:not(.swiper-slide-duplicate)').length;
        if (this.mainCounterTotal < 2) return;

        const prevBtn = nav.querySelector('.swiper-button-prev');
        const counter = document.createElement('span');
        counter.className = 'm-main-counter';
        counter.textContent = '1 / ' + this.mainCounterTotal;

        if (prevBtn) {
          prevBtn.insertAdjacentElement('afterend', counter);
        } else {
          nav.appendChild(counter);
        }

        this.mainCounterEl = counter;
      }

      updateMainCounter(realIndex) {
        if (!this.mainCounterEl || !this.mainCounterTotal) return;
        this.mainCounterEl.textContent = (realIndex + 1) + ' / ' + this.mainCounterTotal;
      }

      handleSlideChange() {
        if (!this.slider) return;

        this.slider.on("slideChange", (swiper) => {
          window.pauseAllMedia(this);

          const realIndex = swiper.realIndex;
          this.setActiveThumbnail(realIndex);
          this.updateMainCounter(realIndex);

          const { slides, activeIndex } = swiper;
          const activeSlide = slides[activeIndex];
          if (activeSlide) this.playActiveMedia(activeSlide);

          const visibleSlides = [activeIndex];
          if (["layout-5", "layout-7"].includes(this.layout)) {
            visibleSlides.push(activeIndex + 1);
          }

          const hasModelMediaType = visibleSlides.some((index) => {
            const slide = slides[index];
            return slide && slide.dataset.mediaType === "model";
          });

          this.toggleSliderDraggableState(!hasModelMediaType);
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.slider.allowTouchMove !== isDraggable) {
          this.slider.allowTouchMove = isDraggable;
        }
      }

      handleAutoplayVideo() {
        const playVideo = (mediaElement) => {
          const mediaType = mediaElement.dataset.mediaType;
          if (mediaType === "video" || mediaType === "external_video") {
            const deferredMedia = mediaElement.querySelector("deferred-media");
            const autoplay = deferredMedia && deferredMedia.dataset.autoPlay === "true";
            if (autoplay) deferredMedia.loadContent(false);
          }
        };

        if (this.slider) {
          const { slides, activeIndex } = this.slider;
          const activeSlide = slides[activeIndex];
          if (activeSlide) playVideo(activeSlide);
        } else {
          this.domNodes.medias.forEach(playVideo);
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector("deferred-media");
        if (!deferredMedia || deferredMedia.dataset.autoPlay !== "true") return;

        const playMedia = (element) => {
          if (element.classList.contains("js-youtube") || element.classList.contains("js-vimeo")) {
            const platform = element.classList.contains("js-youtube") ? "youtube" : "vimeo";
            const param = platform === "youtube" ? "mute=1" : "muted=1";
            const symbol = element.src.includes("?") ? "&" : "?";
            element.src += `${symbol}autoplay=1&${param}`;
          } else {
            element.play();
          }
        };

        if (!deferredMedia.hasAttribute("loaded")) {
          deferredMedia.loadContent(false);
        }

        const deferredElement = deferredMedia.querySelector("video, model-viewer, iframe");
        playMedia(deferredElement);
      }

      handlePhotoswipe() {
        const medias = [...this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)")];

        const data = medias.map((media) => {
          const { mediaType, index: id } = media.dataset;

          if (mediaType === "image") {
            const {
              mediaSrc: src,
              mediaWidth,
              mediaHeight,
              mediaAlt: alt,
            } = media.querySelector(".m-product-media").dataset;
            return {
              src,
              width: parseInt(mediaWidth),
              height: parseInt(mediaHeight),
              alt,
              id,
            };
          } else {
            return {
              html: `<div class="pswp__${mediaType}">${media.innerHTML}</div>`,
              type: mediaType,
              id,
            };
          }
        });

        const options = {
          dataSource: data,
          bgOpacity: 1,
          close: false,
          zoom: false,
          arrowNext: false,
          arrowPrev: false,
          counter: true,
          preloader: false,
          pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
          // FIX: senza questo, la striscia miniature (in overlay assoluto)
          // si sovrapponeva alla foto principale e ai controlli invece di
          // stare in uno spazio proprio sotto di essa. paddingFn dice a
          // PhotoSwipe di trattare gli ultimi 92px in basso come "non
          // disponibili" per la foto: la foto si ridimensiona/centra da
          // sola SOPRA quello spazio, che resta libero per la striscia.
          // ITALMINERAL: la lente ingrandisce la foto fino a riempire tutta la larghezza
          // dello schermo (prima si fermava a 1200px e restavano bande nere ai lati);
          // un secondo livello di zoom resta disponibile.
          secondaryZoomLevel: (zl) => Math.max(zl.panAreaSize.x / zl.elementSize.x, zl.panAreaSize.y / zl.elementSize.y, 1),
          maxZoomLevel: (zl) => Math.max(zl.panAreaSize.x / zl.elementSize.x * 1.5, 2),
          paddingFn: () => {
            // FIX: top:12 da' un minimo di respiro sopra la foto (prima era
            // schiacciata al bordo). bottom:116 = 84px zona miniature
            // (8 margine + 8 padding + 60 miniatura + 8 padding) + 32px
            // fascia contatore (8+8 padding + ~16 testo), calcolati per
            // combaciare esattamente con i valori del CSS, senza vuoti.
            return { top: 12, bottom: 116, left: 0, right: 0 };
          },
        };
        this.imPswpData = data; // ITALMINERAL: usato da applyMediaOrder()
        this.lightbox = new MinimogLibs.PhotoSwipeLightbox(options);

        this.lightbox.addFilter("thumbEl", (thumbEl, { id }, index) => {
          return this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`) || thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, { data: { id } }) => {
          const el = this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`);
          return el ? el.src : placeholderSrc;
        });

        this.lightbox.on("change", () => {
          window.pauseAllMedia(this);
          if (this.slider) {
            const { currIndex } = this.lightbox.pswp;
            const slideMethod = this.enableVariantGroupImages ? "slideTo" : "slideToLoop";
            this.slider[slideMethod](currIndex, 100, false);
          }
        });

        this.lightbox.on("pointerDown", (e) => {
          if (this.lightbox.pswp.currSlide.data.type === "model") {
            e.preventDefault();
          }
        });

        // FIX: striscia di miniature DENTRO al lightbox (non solo le
        // frecce/contatore che c'erano gia'). Costruita come elemento UI
        // custom di PhotoSwipe, popolata dalle stesse foto di "data" qui
        // sopra - quindi mostra sempre TUTTE le foto, comprese quelle non
        // ancora visibili nella griglia miniature della pagina normale.
        const uiElements = [
          {
            name: "m-close",
            order: 11,
            isButton: true,
            html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
            onClick: (event, el, pswp) => pswp.close(),
          },
          {
            name: "m-arrowNext",
            order: 12,
            isButton: true,
            html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
            onClick: (event, el, pswp) => pswp.next(),
          },
          {
            name: "m-arrowPrev",
            order: 10,
            isButton: true,
            html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
            onClick: (event, el, pswp) => pswp.prev(),
          },
          {
            name: "m-lightbox-thumbnails",
            order: 20,
            appendTo: "wrapper",
            onInit: (el, pswp) => {
              el.className = "pswp__thumbnails";

              // ITALMINERAL: segue l'ordine attuale delle foto (es. dopo "UV")
              (pswp.options.dataSource || data).forEach((item, index) => {
                const thumb = document.createElement("div");
                thumb.className = "pswp__thumbnails__item";
                thumb.dataset.index = index;

                if (item.src) {
                  const img = document.createElement("img");
                  img.src = item.src;
                  img.alt = item.alt || "";
                  thumb.appendChild(img);
                } else {
                  // video/model: nessuna anteprima immagine disponibile qui,
                  // mostriamo solo un riquadro vuoto cliccabile
                  thumb.classList.add("pswp__thumbnails__item--no-image");
                }

                thumb.addEventListener("click", () => {
                  pswp.goTo(index);
                });

                el.appendChild(thumb);
              });

              const setActive = (activeIndex) => {
                el.querySelectorAll(".pswp__thumbnails__item").forEach((node) => {
                  node.classList.toggle("pswp__thumbnails__item--active", Number(node.dataset.index) === activeIndex);
                });
                const activeEl = el.querySelector(".pswp__thumbnails__item--active");
                if (activeEl) {
                  // FIX: il calcolo precedente usava el.scrollLeft (la
                  // posizione di scroll ATTUALE) + un offset calcolato da
                  // getBoundingClientRect (anch'essa dipendente dalla
                  // posizione di scroll corrente). Se si cliccava "avanti"
                  // velocemente, prima che l'animazione fluida del click
                  // precedente finisse, questi valori venivano letti
                  // "a meta'" dell'animazione in corso, e l'errore si
                  // accumulava ad ogni click nella stessa direzione -
                  // esattamente il sintomo descritto (deriva progressiva
                  // in una direzione, corretta andando nell'altra).
                  // offsetLeft e' invece la posizione FISSA dell'elemento
                  // dentro al contenuto scrollabile, indipendente da
                  // quanto e' scrollato in questo momento o da eventuali
                  // animazioni ancora in corso - il calcolo risulta
                  // sempre lo stesso, identico, per lo stesso indice.
                  const targetScrollLeft = activeEl.offsetLeft - (el.clientWidth / 2) + (activeEl.offsetWidth / 2);
                  el.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
                }
              };

              pswp.on("change", () => setActive(pswp.currIndex));
              setActive(pswp.currIndex);
            },
          },
        ];

        this.lightbox.on("uiRegister", () => {
          this.lightbox.pswp.ui.registerElement(uiElements[0]);
          if (!this.onlyMedia) {
            uiElements.slice(1).forEach((element) => this.lightbox.pswp.ui.registerElement(element));
          }
        });

        this.lightbox.init();

        const handleMediaClick = (e, media) => {
          e.preventDefault();
          const isImage = media.classList.contains("media-type-image");
          const isZoomButton = e.target.closest(this.selectors.mediaZoomIns[0]);

          if (isImage || isZoomButton) {
            const index = Number(media.dataset.index) || 0;
            this.lightbox.loadAndOpen(index);
          }
        };

        addEventDelegate({
          selector: this.selectors.medias[0],
          context: this,
          handler: handleMediaClick,
        });
      }

      setActiveMedia(variant) {
        if (!variant) return;
        if (this.slider) {
          this.setActiveMediaForSlider(variant);
        } else {
          this.handleGalleryMode(variant);
        }
      }

      setActiveMediaForSlider(variant) {
        if (variant.featured_media && this.slider && this.slider.wrapperEl) {
          let slideIndex = variant.featured_media.position || 1;
          this.slider.slideToLoop(slideIndex - 1);
        }
      }

      handleGalleryMode(variant) {
        if (this.context !== "featured-product" && variant && variant.featured_media) {
          const selectedMedia = this.querySelector(`.m-media-gallery__list [data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            this.scrollIntoView(selectedMedia);
          }
        }
      }

      scrollIntoView(selectedMedia) {
        selectedMedia.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  );
}

// ITALMINERAL (velocita'): le foto del carosello dalla seconda in poi partono leggere
// (400px, vedi snippets/product-thumbnail.liquid). Al primo gesto del visitatore
// (tocco, clic, scroll, rotella, tastiera) attiviamo le versioni in alta risoluzione.
// Resta in ascolto anche dopo, per le foto aggiunte in seguito (es. anteprima rapida).
(function () {
  if (window.__imGalleryUpgrade) return;
  window.__imGalleryUpgrade = true;
  var pending = false;
  function upgrade() {
    pending = false;
    document.querySelectorAll('img[data-im-srcset]').forEach(function (img) {
      var set = img.getAttribute('data-im-srcset');
      img.removeAttribute('data-im-srcset');
      if (set) img.srcset = set;
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(upgrade);
  }
  ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, schedule, { passive: true, capture: true });
  });
})();
